import { Controller, useFormContext } from 'react-hook-form';
import _ from 'lodash';
import CustomTextArea from '../../CustomTextArea/CustomTextArea';
import { TextAreaField } from '../types';

const TextAreaFieldForm = ({ field }: { field: TextAreaField }) => {
  const {
    control,
    formState: { errors }
  } = useFormContext();
  const currentError = _.get(errors, field.key);
  return (
    <div>
      <Controller
        name={field.key}
        control={control}
        render={({ field: renderField }) => (
          <CustomTextArea
            label={field.label}
            value={renderField.value || ''}
            placeholder={field.placeholder}
            isDsabled={field.disabled as boolean}
            onChange={(e) => renderField.onChange(e.target.value)}
          />
        )}
      />
      {currentError && <p className="text-danger" style={{ fontSize: 12 }}>{(currentError as any).message}</p>}
    </div>
  );
};

export default TextAreaFieldForm;
